import { CREATE_FORECAST_TITLE, EDIT_FORECAST_TITLE, VIEW_FORECAST_TITLE } from '../constants';

export const getHeaderData = (isEdit: boolean, isView: boolean) => {
  if (isEdit) {
    return {
      testId: EDIT_FORECAST_TITLE,
      title: 'forecast.edit',
      titleSlug: 'edit-forecast',
    };
  }

  if (isView) {
    return {
      testId: VIEW_FORECAST_TITLE,
      title: 'forecast.view',
      titleSlug: 'view-forecast',
    };
  }

  return {
    testId: CREATE_FORECAST_TITLE,
    title: 'forecast.create',
    titleSlug: 'create-forecast',
  };
};
